import gql from 'graphql-tag';

import { PhotoDownloadDetails } from '../fragments/photo-downloads';

export const PhotoDownloadCreate = gql`
  mutation photoDownloadCreate($input: PhotoDownloadCreateInput!) {
    photoDownloadCreate(input: $input) {
      success
      photo_download {
        id
        ...PhotoDownloadDetails
      }
    }
  }
  ${PhotoDownloadDetails}
`;

export const AccountCardsPhotoDownloadCreate = gql`
  mutation accountCardsPhotoDownloadCreate(
    $input: AccountCardsPhotoDownloadCreateInput!
  ) {
    accountCardsPhotoDownloadCreate(input: $input) {
      success
      photo_download {
        id
        ...PhotoDownloadDetails
      }
    }
  }
  ${PhotoDownloadDetails}
`;
